import React from "react";

const POPendingSummaryCard = ({
    data = {},
    onClick
}) => {

    // ==========================================
    // COUNTS FROM DASHBOARD API
    // ==========================================

    const total = Number(
        data?.totalPendingPO || 0
    );

    const maker = Number(
        data?.totalPendingPOMaker || 0
    );

    const checker = Number(
        data?.totalPendingPOChecker || 0
    );

    const ho = Number(
        data?.totalPendingPOHO || 0
    );

    const amendment = Number(
        data?.totalPendingPOAmendment || 0
    );


    // ==========================================
    // SUMMARY CARDS
    // ==========================================

    const summaryItems = [
        {
            key: "maker",
            label: "PO Preparation",
            value: maker,
            icon: "fa fa-user",
            subLabel: "Assigned-To-Maker",

            background:
                "linear-gradient(135deg, #ff9800 0%, #f57c00 100%)",

            iconBackground:
                "rgba(255,255,255,0.20)"
        },

        {
            key: "checker",
            label: "PO Verification",
            value: checker,
            icon: "fa fa-check-square-o",

            subLabel:
                "Generated / Assigned-To-Checker",

            background:
                "linear-gradient(135deg, #2196f3 0%, #1565c0 100%)",

            iconBackground:
                "rgba(255,255,255,0.20)"
        },

        {
            key: "ho",
            label: "HO Approval",
            value: ho,
            icon: "fa fa-shield",

            subLabel:
                "Assigned to HO",

            background:
                "linear-gradient(135deg, #7e57c2 0%, #5e35b1 100%)",

            iconBackground:
                "rgba(255,255,255,0.20)"
        },

        {
            key: "amendment",
            label: "PO Amendments",
            value: amendment,
            icon: "fa fa-pencil",

            subLabel:
                "Assigned to HO",

            background:
                "linear-gradient(135deg, #26a69a 0%, #00796b 100%)",

            iconBackground:
                "rgba(255,255,255,0.20)"
        }
    ];


    // ==========================================
    // CLICK HANDLER
    // ==========================================

    const handleCardClick = (type) => {

        if (!onClick) return;

        onClick(type);
    };


    return (

        <div
            className="card border-0 mb-3"
            style={{
                borderRadius: "16px",

                overflow: "visible",

                // REMOVE FULL RED BACKGROUND
                background: "transparent",

                // SAME CLEAN OUTER SHADOW
                boxShadow:
                    "0 6px 18px rgba(0,0,0,0.08)"
            }}
        >

            {/* ================= HEADER ================= */}

            <div
                className="
                    d-flex
                    justify-content-between
                    align-items-center
                    flex-wrap
                    gap-2
                "
                style={{
                    padding:
                        "10px 14px 3px 14px"
                }}
            >

                <div>

                    <div
                        className="
                            d-flex
                            align-items-center
                            gap-2
                        "
                    >

                        <h4
                            className="mb-0"
                            style={{
                                fontSize: "17px",

                                fontWeight: 700,

                                color: "#212529"
                            }}
                        >
                            Purchase Order Approvals
                        </h4>


                        <span
                            className="badge"
                            style={{
                                background:
                                    "#ff2d55",

                                color:
                                    "#ffffff",

                                border:
                                    "1px solid #ff2d55",

                                fontSize:
                                    "9px",

                                padding:
                                    "4px 8px"
                            }}
                        >
                            NEW
                        </span>

                    </div>


                    <div
                        className="mt-1"
                        style={{
                            color:
                                "#6c757d",

                            fontSize:
                                "10px"
                        }}
                    >
                        Overview of all pending PO approvals
                    </div>

                </div>


                {/* ================= VIEW DETAILS ================= */}

                <button
                    type="button"
                    className="btn btn-sm"
                    style={{
                        color:
                            "#343a40",

                        border:
                            "1px solid #ced4da",

                        borderRadius:
                            "8px",

                        padding:
                            "5px 11px",

                        fontSize:
                            "11px",

                        fontWeight:
                            600,

                        boxShadow:
                            "0 2px 6px rgba(0,0,0,0.06)"
                    }}
                    onClick={() =>
                        handleCardClick("po")
                    }
                >
                    View Details
                </button>

            </div>


            {/* ================= BODY ================= */}

            <div
                style={{
                    padding:
                        "7px 12px 18px"
                }}
            >

                <div className="row g-2">


                    {/* ================= TOTAL ================= */}

                    <div className="col-xl-3 col-lg-4 col-md-12">

                        <div
                            onClick={() =>
                                handleCardClick("po")
                            }
                            style={{
                                cursor:
                                    "pointer",

                                height:
                                    "100%",

                                minHeight:
                                    "88px",

                                borderRadius:
                                    "11px",

                                padding:
                                    "11px",

                                // KEEP TOTAL BOX RED
                                background:
                                    "linear-gradient(135deg, #ff4d6d 0%, #e91e4d 100%)",

                                border:
                                    "1px solid rgba(255,255,255,0.30)",

                                boxShadow:
                                    "0 6px 14px rgba(120,0,25,0.18)"
                            }}
                        >

                            <div
                                className="
                                    d-flex
                                    align-items-center
                                    gap-2
                                "
                            >

                                {/* ICON */}

                                <div
                                    className="
                                        d-flex
                                        align-items-center
                                        justify-content-center
                                    "
                                    style={{
                                        width:
                                            "42px",

                                        height:
                                            "42px",

                                        borderRadius:
                                            "50%",

                                        background:
                                            "rgba(255,255,255,0.20)",

                                        flexShrink:
                                            0
                                    }}
                                >

                                    <i
                                        className="fa fa-shopping-cart"
                                        aria-hidden="true"
                                        style={{
                                            fontSize: "18px",
                                            color: "#ffffff"
                                        }}
                                    />

                                </div>


                                {/* COUNT */}

                                <div>

                                    <div
                                        style={{
                                            fontSize:
                                                "25px",

                                            fontWeight:
                                                700,

                                            lineHeight:
                                                1,

                                            color:
                                                "#ffffff"
                                        }}
                                    >
                                        {total}
                                    </div>


                                    <div
                                        className="mt-1"
                                        style={{
                                            fontSize:
                                                "11px",

                                            fontWeight:
                                                600,

                                            color:
                                                "#ffffff"
                                        }}
                                    >
                                        Total Pending
                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>


                    {/* ================= BREAKUP ================= */}

                    <div className="col-xl-9 col-lg-8 col-md-12">

                        <div className="row g-2">

                            {summaryItems.map(
                                (summary) => (

                                    <div
                                        key={
                                            summary.key
                                        }
                                        className="
                                            col-xl-3
                                            col-lg-6
                                            col-md-6
                                            col-sm-6
                                        "
                                    >

                                        <div
                                            onClick={() =>
                                                handleCardClick(
                                                    summary.key ===
                                                        "amendment"
                                                        ? "poAmendment"
                                                        : "po"
                                                )
                                            }
                                            style={{
                                                cursor:
                                                    "pointer",

                                                height:
                                                    "100%",

                                                minHeight:
                                                    "88px",

                                                borderRadius:
                                                    "11px",

                                                padding:
                                                    "10px",

                                                background:
                                                    summary.background,

                                                border:
                                                    "1px solid rgba(255,255,255,0.28)",

                                                boxShadow:
                                                    "0 6px 14px rgba(0,0,0,0.16)"
                                            }}
                                        >

                                            <div
                                                className="
                                                    d-flex
                                                    align-items-center
                                                    gap-2
                                                "
                                            >

                                                {/* ICON */}

                                                <div
                                                    className="
                                                        d-flex
                                                        align-items-center
                                                        justify-content-center
                                                    "
                                                    style={{
                                                        width:
                                                            "38px",

                                                        height:
                                                            "38px",

                                                        borderRadius:
                                                            "50%",

                                                        background:
                                                            summary.iconBackground,

                                                        flexShrink:
                                                            0
                                                    }}
                                                >

                                                    <i
                                                        className={
                                                            summary.icon
                                                        }
                                                        style={{
                                                            fontSize:
                                                                "16px",

                                                            color:
                                                                "#ffffff"
                                                        }}
                                                    />

                                                </div>


                                                {/* COUNT + LABEL */}

                                                <div>

                                                    <div
                                                        style={{
                                                            fontSize:
                                                                "21px",

                                                            fontWeight:
                                                                700,

                                                            lineHeight:
                                                                1,

                                                            color:
                                                                "#ffffff"
                                                        }}
                                                    >
                                                        {
                                                            summary.value
                                                        }
                                                    </div>


                                                    <div
                                                        className="mt-1"
                                                        style={{
                                                            fontSize:
                                                                "11px",

                                                            fontWeight:
                                                                600,

                                                            color:
                                                                "#ffffff"
                                                        }}
                                                    >
                                                        {
                                                            summary.label
                                                        }
                                                    </div>

                                                </div>

                                            </div>


                                            {/* STATUS */}

                                            <div
                                                className="mt-2"
                                                style={{
                                                    fontSize:
                                                        "9px",

                                                    fontWeight:
                                                        500,

                                                    lineHeight:
                                                        "12px",

                                                    color:
                                                        "rgba(255,255,255,0.90)",

                                                    minHeight:
                                                        "12px"
                                                }}
                                            >
                                                {
                                                    summary.subLabel
                                                }
                                            </div>

                                        </div>

                                    </div>

                                )
                            )}

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
};


export default POPendingSummaryCard;